import {Utils} from '@astek/utils';
import {JsonConfigInterface} from './json-config-interface';
import {BorderConfig, BorderConfigJson} from './border-config';
import {ArrowsConfig, ArrowsConfigJson} from './arrows-config';

export type HandlesConfigJson = {
  timeSize: number;
  pressureSize: number;
  lines: BorderConfigJson;
  arrows: ArrowsConfigJson;
};

export class HandlesConfig implements JsonConfigInterface<HandlesConfigJson> {

  public readonly lines: BorderConfig = new BorderConfig();
  public readonly arrows: ArrowsConfig = new ArrowsConfig();

  private _timeSize: number = 0;
  private _pressureSize: number = 0;

  constructor(json?: HandlesConfigJson) {
    if (!Utils.isNullOrUndefined(json)) {
      this.deserializeJson(json);
    }
  }

  public get timeSize(): number {
    return this._timeSize;
  }

  public get pressureSize(): number {
    return this._pressureSize;
  }

  public deserializeJson(json: HandlesConfigJson): void {
    this._timeSize = json.timeSize;
    this._pressureSize = json.pressureSize;
    this.lines.deserializeJson(json.lines);
    this.arrows.deserializeJson(json.arrows);
  }
}
